import { Component, type OnInit, type OnDestroy } from "@angular/core";
import { CommonModule } from "@angular/common";
interface CarouselSlide {
  id: number;
  title: string;
  description: string;
  icon: string;
  bgColor: string;
  iconColor: string;
  hasBackgroundImage?: boolean;
  backgroundImage?: string;
}
@Component({
  selector: "app-landing-page-carousel",
  templateUrl: "./landing-page-carousel.component.html",
  styleUrls: ["./landing-page-carousel.component.css"],
})
export class LandingPageCarouselComponent implements OnInit, OnDestroy {
  currentSlide = 0;
  isAutoPlaying = true;
  private autoPlayInterval?: number;

  slides: CarouselSlide[] = [
    {
      id: 1,
      title: "Comprehensive Student Management",
      description:
        "Track student enrollment, academic progress, and performance across all educational levels with real-time data synchronization and detailed analytics.",
      icon: "bi-people",
      bgColor: "from-kemis-blue to-kemis-dark-blue",
      iconColor: "text-white",
      hasBackgroundImage: true,
      backgroundImage: "../../../assets/img/landing_page/graduation-bg.jpeg",
    },
    {
      id: 2,
      title: "Advanced Analytics & Reporting",
      description:
        "Generate detailed reports and insights with powerful data visualization tools to support evidence-based decision making at all administrative levels.",
      icon: "bi-bar-chart",
      bgColor: "from-kemis-sky-blue to-kemis-blue",
      iconColor: "text-white",
      hasBackgroundImage: true,
      backgroundImage: "../../../assets/img/landing_page/cbc-profile.png",
    },
    {
      id: 3,
      title: "Secure Data Management",
      description:
        "Bank-level security protocols ensure your educational data is protected with encrypted storage, secure access controls, and compliance with data protection standards.",
      icon: "bi-shield-check",
      bgColor: "from-kemis-dark-blue to-kemis-sky-blue",
      iconColor: "text-white",
      hasBackgroundImage: true,
      backgroundImage: "../../../assets/img/landing_page/cbc2.jpg",
    },
  ];

  ngOnInit(): void {
    this.startAutoPlay();
  }

  ngOnDestroy(): void {
    this.stopAutoPlay();
  }

  goToSlide(index: number): void {
    this.currentSlide = index;
    this.pauseAutoPlay();
  }

  goToPrevious(): void {
    this.currentSlide =
      (this.currentSlide - 1 + this.slides.length) % this.slides.length;
    this.pauseAutoPlay();
  }

  goToNext(): void {
    this.currentSlide = (this.currentSlide + 1) % this.slides.length;
    this.pauseAutoPlay();
  }

  private startAutoPlay(): void {
    if (!this.isAutoPlaying) return;

    this.autoPlayInterval = window.setInterval(() => {
      this.currentSlide = (this.currentSlide + 1) % this.slides.length;
    }, 5000);
  }

  private stopAutoPlay(): void {
    if (this.autoPlayInterval) {
      clearInterval(this.autoPlayInterval);
      this.autoPlayInterval = undefined;
    }
  }

  private pauseAutoPlay(): void {
    this.isAutoPlaying = false;
    this.stopAutoPlay();

    // Resume auto-play after 10 seconds of manual interaction
    setTimeout(() => {
      this.isAutoPlaying = true;
      this.startAutoPlay();
    }, 10000);
  }
}
